import axios from 'axios'
import { EVENT_BUS } from '.'
import { notify } from '../plugins/breadstick'

const BASE_URL = process.env.VUE_APP_BASE_URL

const $axios = axios.create({
  baseURL: BASE_URL,
  timeout: 120000
})

/**
 * Token notification timeout
 */
let tokenTimeout = null

/**
 * Notifies client to login if token is expired
 */
const notifyExpiredToken = () => notify('Your token is expired. Please login to continue', {
  type: 'error',
  title: 'Expired token'
})

/**
 * Error handler for axios response interceptor
 * @param {Object} error Axios error response
 */
const successHandler = (response) => {
  return response
}

/**
 * Error handler for axios response interceptor
 * @param {Object} error Axios error response
 */
const errorHandler = (error) => {
  if (
    error.response &&
    error.response.data &&
    typeof error.response.data === 'string' &&
    error.response.data.includes('Invalid token.')) {
    if (!tokenTimeout) {
      notifyExpiredToken()

      tokenTimeout = setTimeout(() => {
        tokenTimeout = null
      }, 1000)
    }

    setTimeout(async () => {
      EVENT_BUS.$emit('token:expired')
    }, 3000)
  }

  return Promise.reject(error)
}

$axios.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

export {
  $axios
}
